module.exports = {
        srcSet: __webpack_public_path__ + "static/media/KlarWatt-Horizontal-mobile-640.be38a02b.webp"+" 640w",
        images: [{path: __webpack_public_path__ + "static/media/KlarWatt-Horizontal-mobile-640.be38a02b.webp",width: 640,height: 359}],
        src: __webpack_public_path__ + "static/media/KlarWatt-Horizontal-mobile-640.be38a02b.webp",
        toString: function(){return __webpack_public_path__ + "static/media/KlarWatt-Horizontal-mobile-640.be38a02b.webp"},
        
        width: 640,
        height: 359
      }